import React from 'react'
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormAttachment from '../../../../library/form/components/FormAttachment';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const StockCheckListSystemRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <div
            style={{
                minHeight: "310px",
                maxHeight: "310px",
                display: "flex", 
                flexDirection: "column",
                justifyContent: "space-between"
            }}
            className="uiBoxBlue uiBoxSection uiContentCenter uiBorderRoundAll uiBoxSection200"
        >
            <div>
                <div className="uiSpacer5">
                    <div className="uiBlock uiContentCenter">
                        <FormROValue format="#" formObject={formObject} className="uiSpacerH5 uiHighlightText" rowKey={rowKey} action={{ paramName: "itemId" }} />
                    </div>

                    <div style={{ margin: "3px auto", width: "100%", backgroundColor: "#fff", textAlign: "center", minHeight: "60px" }}>
                        <FormAttachment imgStyle={{ cursor: "pointer", width: "100px" }} formObject={formObject} rowKey={rowKey} action={{ InputType: "i", paramName: "itemImage" }} />
                    </div>

                    <FormROValue style={{ height: "30px", fontSize: "11px", overflow:"hidden" }} className="uiBlock" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "pItemId" }} />
                    <FormROValue style={{ height: "30px", fontSize: "11px", overflow:"hidden" }} className="uiBlock" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />

                    <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "systemCount" }} >
                        <span className="uiBlock uiLeftAlignText" style={{  fontSize: "11px" }}>
                            <span className='uiSpacerR5 uiBold'><SarasTrans value="System Count" /></span><FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "systemCount" }} className="uiHighlightBlueRegular"/>
                        </span>
                    </FormWrapper>
                    <FormWrapper customWrapper="" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} >
                        <span className="uiCenterAlignText" style={{height: "20px", fontSize: "11px" }}>
                            <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "comment" }} className='uiSpacerH5' />
                        </span>
                    </FormWrapper> 
                </div>
            </div>
            <div className="uiSpacer5">
                <FormWrapper customWrapper="" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "markMissingBtn" }} >
                    <FormButton formObject={formObject} rowKey={rowKey} confirm="Are you sure to Mark Item as Missing?"
                            action={{ actionId: "refresh", refreshMode:"self", paramName: "markMissingBtn", actionParam: {actionType:"requestMarkMissing"}, containerKey: "" }}
                            className="" text={<SarasTrans value="Missing" />}></FormButton>
                    <FormButton formObject={formObject} rowKey={rowKey}
                        className="" text={<SarasTrans value="Count" />}
                        action={{ actionId: "edit", actionParam: {pathKey: "counting"}, containerKey: "popup" }}
                    ></FormButton>
                </FormWrapper>
                <FormWrapper customWrapper="" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "delBtn" }} >
                    <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    className=""
                        action={{ actionId: "edit", refreshMode:"self", paramName: "delBtn", actionParam: {actionType:"requestItemDelete"}, containerKey: "popup" }}
                    ></FormButton>
                </FormWrapper>
                <FormWrapper customWrapper="" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "stockStatus" }} >
                    <span className="uiCenterAlignText" style={{height: "20px", fontSize: "11px" }}>
                        <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "stockStatus" }} className='uiSpacerH5 uiBold' />
                    </span> 
                </FormWrapper>  
            </div>
        </div>
    )
}

export default StockCheckListSystemRow